// extracted by mini-css-extract-plugin
export default {"svg":"IconLibrary_svg__RSfUK","tag":"IconLibrary_tag__2AIvs","container":"IconLibrary_container__P9FUZ"};